/* Shared lookups for the Program Planner module — colors, stages, roles, table config. */

export { STATUS_META, STATUS_OPTIONS, STATUS_IDS, STATUS_TAB_COUNT_KEYS } from '../shared_components';

export const PROJECT_TYPE_OPTIONS = [
  { id: 1, name: 'Mid-Term Inspection' },
  { id: 2, name: 'Pre-Purchase Inspection' },
  { id: 3, name: 'Lease Return' },
  { id: 4, name: 'Delivery Inspection' },
  { id: 5, name: 'Misc. Service' },
];

export const REPORT_STATUS_IDS = { Open: 1, Closed: 2 };

export const ASSET_TYPE_OPTIONS = [
  { id: 1, name: 'Aircraft' },
  { id: 2, name: 'Engine' },
  { id: 3, name: 'APU' },
  { id: 4, name: 'Landing Gear' },
  { id: 5, name: 'Propeller' },
];

/* Role → action permission map (BRD §4). Swap for API-driven permissions once
   the backend exposes a program_planner permission key. */
export const ROLES = {
  Admin: { create: true, launch: true, link: true, stages: true, edit: true, del: true },
  'Project Lead': { create: true, launch: true, link: true, stages: true, edit: true, del: true },
  'TAM Rep': { create: false, launch: false, link: false, stages: false, edit: false, del: false },
  'Client User': { create: false, launch: false, link: false, stages: false, edit: false, del: false },
};


export const REPORT_STATUS_OPTIONS = Object.entries(REPORT_STATUS_IDS).map(([label, id]) => ({ id, label }));

export const WIZARD_STEPS = [
  { key: 'basic', label: 'Basic Info', nextLabel: 'Assets' },
  { key: 'assets', label: 'Assets', nextLabel: 'Timeline' },
  { key: 'timeline', label: 'Timeline', nextLabel: 'Team' },
  { key: 'team', label: 'Team', nextLabel: 'Tracking' },
  { key: 'review', label: 'Tracking', nextLabel: null },
];

export const plannerHd = [
  { id: 'name', label: 'Project', sortOption: true, width: 280 },
  { label: 'Current Stage', sortOption: false, width: 100 },
  { id: 'lessor', label: 'Lessor', sortOption: true },
  { id: 'lessee', label: 'Lessee', sortOption: true },
  // { id: 'inspection_type', label: 'Inspection Type', sortOption: true },
  { id: 'start', label: 'Project Allocation Date', sortOption: true,  width: 120 },
  { id: 'end', label: 'Expected End', sortOption: true,  width: 100 },
  { id: 'assets', label: 'Assets', sortOption: true },
  { label: 'Status', sortOption: false },
  { id: 'created_by', label: 'Created By', sortOption: true,  width: 100 },
  { id: 'created_at', label: 'Created At', sortOption: true,  width: 100 },
  { id: 'updated_by', label: 'Updated By', sortOption: true,  width: 100 },
  { id: 'updated_at', label: 'Updated At', sortOption: true,  width: 100 },
  { label: 'Action(s)', sortOption: false, actionCell: true },
];

export const plannerFilterOps = {
  lessor: {
    inputType: 'dropdown',
    title: 'Lessor',
    options: [],
    labelKey: 'name',
    valueKey: 'name',
    multiple: true,
  },
  itype: {
    inputType: 'dropdown',
    title: 'Inspection Type',
    options: [],
    labelKey: 'name',
    valueKey: 'name',
    multiple: true,
  },
};

export const emptyPlan = {
  slug: null,
  name: '',
  project_type: null,
  inspection_type: null,
  lessor: null,
  lessee: null,
  stage_template: null,
  location: '',
  client: null,
  planned_start_date: '',
  planned_end_date: '',
  status: 'Draft',
  current_stage: null,
  expected_asset_count: '',
  assets: [],
  reps: [],
  cvs: [],
  tag: '',
  report_status_records: { id: REPORT_STATUS_IDS.Open, label: 'Open' },
  report_status_physical: { id: REPORT_STATUS_IDS.Open, label: 'Open' },
  report_submission_date: '',
  client_acceptance_date: '',
  remarks_records: '',
  remarks_physical: '',
};
